import React, { useState } from 'react'
import { MARKI_Z_LOGO } from './markiZLogo'

/**
 * Logo producenta komponentu — małe, obok nazwy modelu.
 *
 * SKĄD BIERZEMY PRODUCENTA: pozycja zestawu go NIE NIESIE (`items` mają nazwę
 * modelu, spec i slug, ale nie markę). Szukamy więc znanej marki wewnątrz sluga.
 *
 * SZUKAMY W CAŁYM SLUGU, nie w jego początku — bo marka rzadko stoi na pierwszym
 * miejscu. Realne przykłady z bazy:
 *   fotowoltaiczny-ja-solar-365w-jam60s21-mr-full-black   → jasolar
 *   modul-bateryjny-dyness-lv-dl5-0c-eu                   → dyness
 *   inwerter-deye-sun-6k-sg05lp1-eu-1-fazowy-hybrydowy-lv → deye
 * Dopasowanie po prefiksie łapało tylko przypadki w rodzaju `growatt-spf-6000`,
 * czyli mniejszość.
 *
 * Lista marek (`markiZLogo.js`) jest generowana z zawartości katalogów
 * `public/*_manufacturers`, więc pytamy o plik dopiero, gdy wiemy, że istnieje —
 * zamiast strzelać kolejnymi nazwami i zbierać serie 404.
 *
 * GDY MARKI NIE MA NA LIŚCIE, komponent znika bez śladu. Katalog pokrywa 56 marek
 * modułów, 57 falowników i 58 magazynów — to nie wszystko, co jest w bazie. Pusta
 * ramka przy co którymś produkcie wyglądałaby na awarię, a brak logo nie mówi nic
 * złego o produkcie.
 */

const KATALOG = {
  panels: 'panels_manufacturers',
  inverter: 'inverters_manufacturers',
  battery: 'magazines_manufacturers',
}

/**
 * Marka rozpoznana w slugu albo `null`.
 *
 * Slug sklejamy do jednego ciągu bez myślników, bo w katalogu nazwy plików też
 * są bez separatorów („JA Solar" → `jasolar.jpg`), a w slugu ta sama marka jest
 * rozbita na człony (`ja-solar`).
 */
export const markaZeSluga = (slug, kategoria) => {
  const marki = MARKI_Z_LOGO[kategoria]
  if (!marki || !slug) return null
  const sklejony = String(slug).toLowerCase().replace(/-/g, '')
  // Lista jest posortowana od najdłuższej nazwy, więc pierwsze trafienie jest
  // najbardziej szczegółowe („canadiansolar", a nie fragment krótszej marki).
  return marki.find((marka) => sklejony.includes(marka.replace(/-/g, ''))) || null
}

const LogoProducenta = ({ slug, kategoria, className = '' }) => {
  const [bladWczytania, setBladWczytania] = useState(false)
  const marka = markaZeSluga(slug, kategoria)
  const katalog = KATALOG[kategoria]

  if (!marka || !katalog || bladWczytania) return null

  return (
    <img
      src={`${process.env.PUBLIC_URL}/${katalog}/${marka}.jpg`}
      alt=""
      aria-hidden="true"
      onError={() => setBladWczytania(true)}
      className={`h-5 w-auto max-w-[72px] object-contain ${className}`}
    />
  )
}

export default LogoProducenta
